import React from 'react';
import FormSection from '../FormSection';
import { StepNumberIcon } from '../../icons';
import type { UserIdentificationFormProps } from './types/user-identification.types';
import { useUserIdentification } from './hooks/useUserIdentification';
import FullNameField from './components/FullNameField';
import EmailField from './components/EmailField';
import CpfField from './components/CpfField';
import PhoneField from './components/PhoneField';
import BirthDateField from './components/BirthDateField';
import IdentificationButtons from './components/IdentificationButtons';

const UserIdentificationForm: React.FC<UserIdentificationFormProps> = (props) => {
  const {
    formData,
    errors,
    isFullNameValid,
    isEmailValid,
    isCpfValid,
    isPhoneValid,
    isBirthDateValid,
    handleChange,
    handleSubmit,
    handleContactBlur,
  } = useUserIdentification(props);

  return (
    <div className="container mx-auto max-w-2xl">
      <FormSection 
        title="Identifique-se" 
        icon={<StepNumberIcon displayNumber={1} />}
      >
        <form onSubmit={handleSubmit} className="space-y-6">
          <div className="desc mb20">
            Utilizaremos seu e-mail para: Identificar seu perfil, histórico de compra,
            notificação de pedidos e carrinho de compras.
          </div>

          <FullNameField
            value={formData.fullName}
            error={errors.fullName}
            isValid={isFullNameValid}
            onChange={handleChange}
          />

          <EmailField
            value={formData.email}
            error={errors.email}
            isValid={isEmailValid}
            onChange={handleChange}
            onBlur={handleContactBlur}
          />

          <CpfField
            value={formData.cpf || ''}
            error={errors.cpf}
            isValid={isCpfValid}
            cpfOnIdentification={formData.cpfOnIdentification}
            onChange={handleChange}
          />

          {formData.requestBirthDate ? (
            <BirthDateField
              value={formData.birth || ''}
              error={errors.birth}
              isValid={isBirthDateValid}
              onChange={handleChange}
            />
          ) : null}

          <PhoneField
            value={formData.phone}
            error={errors.phone}
            isValid={isPhoneValid}
            onChange={handleChange}
            onBlur={handleContactBlur}
          />

          <IdentificationButtons />
        </form>
      </FormSection>
    </div>
  );
};

export default UserIdentificationForm; 